import { render, staticRenderFns } from "./powered-by.vue?vue&type=template&id=392f7476&"
import script from "./powered-by.vue?vue&type=script&lang=js&"
export * from "./powered-by.vue?vue&type=script&lang=js&"
import style0 from "./powered-by.vue?vue&type=style&index=0&id=392f7476&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports